import type { FeatureFlag } from './feature-flag-types'

export const FeatureFlagName = {
  // ==========================================
  // 100% ATIVA EM PRODUÇÃO
  // todas as flags estão retornando true em produção
  // ==========================================
  COMPANIES_ON_COMPANY_MANAGER_DASHBOARDS: {
    name: 'skillcustomer-companies-on-admin-dashboards',
    defaultValue: false
  },
  DASHBOARDS_IMPACT_LICENSES_AND_RANKING: {
    name: 'skillcustomer-dashboards-impact-licenses-and-ranking',
    defaultValue: false
  },
  COMPANIES_ON_ENROLLMENT_ROLLOUT: {
    name: 'skillweb-company-new-enrollment-interface',
    defaultValue: false
  },
  NEW_ENROLLMENT_COMPLETION: {
    name: 'skillweb-new-enrollment-completion',
    defaultValue: false
  },
  DEPENDENT_USER_PROFILE: {
    name: 'skillcustomer-dependent-user-profile',
    defaultValue: false
  },
  DEPENDENT_REQUEST: {
    name: 'skillcustomer-dependent-request',
    defaultValue: false
  },
  COMPANIES_ON_USER_PROFILE: {
    name: 'skillcustomer-companies-on-user-profile',
    defaultValue: false
  },
  COMPANIES_ON_USER_SETTINGS: {
    name: 'skillcustomer-companies-on-user-security-privacy',
    defaultValue: false
  },
  COMPANIES_ON_USER_INTEREST_AREAS_SKILLS: {
    name: 'skillcustomer-companies-on-user-interest-areas-skills',
    defaultValue: false
  },
  ENABLED_NEW_SOCIAL_NAME_FIELD: {
    name: 'skillcustomer-social-name',
    defaultValue: false
  },
  RH_CREATE_COLLABORATOR_PROFILE: {
    name: 'skillcustomer-rh-create-collaborator-profile',
    defaultValue: false
  },
  RH_EDIT_COLLABORATOR_PROFILE: {
    name: 'skillcustomer-rh-edit-collaborator-profile',
    defaultValue: false
  },
  RH_EDIT_DEPENDENT_PROFILE: {
    name: 'skillcustomer-rh-edit-dependent-profile',
    defaultValue: false
  },
  DISPLAY_CATEGORIES_HIGH_SCHOOL_AND_TECHNICAL: {
    name: 'skillweb-display-categories-high-school-and-technical',
    defaultValue: false
  },
  DISPLAY_AVAILABLE_CATEGORIES: {
    name: 'skillcustomer-display-available-categories',
    defaultValue: false
  },
  SHOW_FULL_CATALOG: {
    name: 'skillweb-show-full-catalog',
    defaultValue: false
  },
  DISABLED_PREFERRED_CONTENT_TYPE_BY_COMPANY_ID: {
    name: 'skillcustomer-disabled-preferred-content-type-by-company-id',
    defaultValue: {}
  },
  USER_BASED_CF_RECOMMENDATIONS: {
    name: 'skillcustomer-user-based-cf-recommendations',
    defaultValue: false
  },
  RECOMMEND_COURSE_BY_CONTENT: {
    name: 'skillcustomer-recommend-course-by-content',
    defaultValue: false
  },
  SUPPORT_ORIGIN_MULTIPLE_TABS: {
    name: 'skillcustomer-support-origin-multiple-tabs',
    defaultValue: false
  },
  SHOW_INSTITUTION_USER_PLATFORM_LINK: {
    name: 'skillcustomer-show-institution-user-platform-link',
    defaultValue: false
  },
  CATEGORIES_AGREEMENT_TERMS: {
    name: 'skillcustomer-categories-agreement-terms',
    defaultValue: false
  },
  LOAD_PROFILE_ASSESSMENT_ON_START: {
    name: 'skillcustomer-load-profile-assessment-on-start',
    defaultValue: true
  },
  I18N: {
    name: 'skillweb-i18n',
    defaultValue: false
  },
  SEARCH_LANGUAGES_FILTER: {
    name: 'skillcustomer-search-languages-filter',
    defaultValue: false
  },
  SEARCH_SUBSCRIPTION_FILTER: {
    name: 'skillcustomer-search-subscription-filter',
    defaultValue: false
  },
  USER_GREETING: {
    name: 'skillcustomer-user-greeting',
    defaultValue: false
  },
  USER_ENROLLMENTS_PAGE: {
    name: 'skillcustomer-user-enrollments-page',
    defaultValue: false
  },
  ENABLE_FAVORITE_COURSES: {
    name: 'skillcustomer-enable-favorite-courses',
    defaultValue: false
  },
  UPGRADE_REQUEST: {
    name: 'skillcustomer-upgrade-request',
    defaultValue: false
  },
  ENABLE_CONTACT_VALIDATION: {
    name: 'skillcustomer-contact-validation',
    defaultValue: false
  },
  NAV_PDV_WITH_PRODUCT_ID: {
    name: 'skillcustomer-nav-pdv-with-product-id',
    defaultValue: false
  },
  INVISIBLE_RECAPTCHA: {
    name: 'skillcustomer-invisible-recaptcha',
    defaultValue: false
  },
  SINGLE_SIGN_ON_OPTIONS: {
    name: 'skillcustomer-single-sign-on-options',
    defaultValue: false
  },
  PRODUCT_FIELD_MIGRATION: {
    name: 'skillweb-product-field-migration',
    defaultValue: false
  },
  ENABLE_CYCLES: {
    name: 'skillcustomer-enable-cycles',
    defaultValue: false
  },
  ENABLE_CYCLES_ENROLLMENT_STEP2: {
    name: 'skillcustomer-enable-cycles-enrollment-step2',
    defaultValue: false
  },
  ENABLE_RH_SUBSIDY_AMOUNT_FIELD: {
    name: 'skillcustomer-enable-rh-subsidy-amount-field',
    defaultValue: false
  },

  // ==========================================
  // 100% DESATIVADA EM PRODUÇÃO
  // todas as flags estão retornando false em produção
  // ==========================================
  ENROLLMENT_REQUIRES_BIOMETRY: {
    name: 'skillweb-auth-require-biometry',
    defaultValue: true
  },
  JOB_DEPARTMENT_REQUIRED: {
    name: 'skillcustomer-job-department-required',
    defaultValue: false
  },

  // ==========================================
  // ATIVA PARCIALMENTE EM PRODUÇÃO
  // Algumas empresas com a flag ativa e outras não
  // ==========================================
  ENROLLMENT_WORKFLOW_TIMELINE: {
    name: 'skillcustomer-enrollment-workflow-timeline',
    defaultValue: false
  },
  COMPANIES_ON_DEPENDENT_ROLLOUT: {
    name: 'skillcustomer-companies-on-dependent',
    defaultValue: false
  },
  DISPLAY_COMPANY_CONTENT_RECOMMENDATIONS: {
    name: 'skillcustomer-display-company-content-recommendations',
    defaultValue: false
  },
  COMPANIES_WITH_PROFILE_ASSESSMENT: {
    name: 'skillcustomer-companies-with-profile-assessment',
    defaultValue: false
  },
  USER_SPACE_ENABLED: {
    name: 'skillcustomer-user-space-enabled',
    defaultValue: false
  },
  ENABLED_UPGRADE_V4: {
    name: 'skillcustomer-upgrade-v4',
    defaultValue: false
  },
  ENABLE_ONBOARDING_CONTACT_VALIDATION: {
    name: 'skillcustomer-onboarding-contact-validation',
    defaultValue: false
  },
  ENABLE_SHARE_LINKEDIN_BUTTON: {
    name: 'skillcustomer-share-linkedin-button',
    defaultValue: false
  },
  INTERNAL_AUTHENTICATION: {
    name: 'skillcustomer-internal-authentication',
    defaultValue: false
  },

  // ==========================================
  // ATIVA PARCIALMENTE COM VARIAÇÕES
  // Algumas empresas com a flag ativa com variações diferentes,
  // possivelmente dependendo do ID da empresa ou outro critério
  // flag infinita para armazenar variações complexas que deveriam ser uma feature da aplicação
  // ==========================================
  ENGAGE_DATA: {
    name: 'skillcustomer-company-dashboards-engage',
    defaultValue: {}
  },
  COMPANIES_WITH_CUSTOM_HELP_CENTER: {
    name: 'skillcustomer-companies-custom-help-center',
    defaultValue: []
  },
  INSTITUTIONS_WITH_LINK_HIDDEN: {
    name: 'skillcustomer-institutions-with-link-hidden',
    defaultValue: false
  },
  PARTNER_CANCEL_NOT_ALLOWED: {
    name: 'skillcustomer-partner-cancel-not-allowed',
    defaultValue: []
  }
} as const

/**
 * Type helper for TypeScript
 */
export type FeatureFlagNameType = typeof FeatureFlagName

/**
 * Helper to get all flags as array
 * Used internally for initialization and caching
 */
export const getAllFlags = (): FeatureFlag[] => Object.values(FeatureFlagName)
